<template>
<div class="List">
  <ul class="ProductList clearfix">
    <li
      v-for="(item, index) of items"
      :key="index">
      <a @click="openDetail(item.pid, item.cid)" :data-pid="item.pid" :data-cid="category" :title="item.name">
        <div class="ProductImg img-wrapper">
          <div
            class="orderIcon"
            v-if="chkOrder(item.pid)>0"><span>已選購</span></div>
          <img :src="item.image_url" :alt="item.name" />
        </div>
        <div class="ProductBody">
          <div class="ProductName">{{item.name}}</div>
          <div class="ProductPrice">
            <span class="Dollor">
              <span class="sym">$</span>
              {{productPrice(item)}}
            </span>
          </div>
        </div>
      </a>
      <div class="ButtonBar">
        <a @click="openBuyItem(item.pid, item.cid)" title="立即買" v-if="checkIsAvailable(item.productStatus)" class="Btn">
          選購
        </a>
        <a v-else :title="productStatusTxt(item.productStatus)" class="Btn soldout">{{productStatusTxt(item.productStatus)}}</a>
      </div>
    </li>
  </ul>

  <productdetail
    v-if="showDetail"
    :pid="nowDetailPid"
    :cid="category"
    v-on:closeDetail="closeDetail" />
  <buyitem
    v-if="showBuyItem"
    v-on:setCartType="setCartType"
    v-on:addToCart="addToCart"
    v-on:hasAdditional="hasAdditional"
    :pid="nowDetailPid"
    :cid="nowDetailCid"
    v-on:closeBuyItem="closeBuyItem" />
</div>
</template>

<script>
import productdetail from "./productdetail.vue";
import buyitem from "./buyitem.vue";
export default {
  name: "products",
  data() {
    return {
      cartType: 1,
      showDetail: false,
      nowDetailPid: null,
      nowDetailCid: null,
      showBuyItem: false,
      items: [],
      tempItems: [],
      cids: [],
      totals: 0,
      nowPage: 1,
      pageLimit: 8,
      totalPage: 0,
      isNextPage: true,
      isAddToCartLoading: false,
      filterItems: {},
      isOrder: [],
      isLoading: false,
      firtimeReady: false
    };
  },
  props: {
    scrollY: {
      type: Number,
      defaults: 0,
    },
    category: {
      type: Number,
      defaults: 0
    },
    categoryIndex: {
      type: Number,
      defaults: 0
    },
    shoppingCart: {
      type: Array,
      defaults: () => []
    }
  },
  created() {
    if (!this.isLoading) {
      if (this.categoryIndex === 0) {
        this.getAPI();
      } else {
        setTimeout(() => {
          this.getAPI();
        }, 3000)
      }
    }
  },
  mounted() {
    this.nowPage = 1
    this.isNextPage = true
  },
  watch: {
    shoppingCart() {
      this.isInCart()
    },
    scrollY(n, o) {
      if (this.firtimeReady) {
        const dom = document.querySelectorAll('.catalog')[this.categoryIndex]
        if (dom) {
          const rectTop = dom.querySelector('li:last-child').offsetTop - (window.innerHeight / 2)
          if (n > o && n > rectTop && !this.isLoading && this.isNextPage) {
            this.getAPI();
          }
        }
      }
    }
  },
  computed: {
    chkOrder() {
      return function (p) {
        const order = this.isOrder.find(i => {
          return i == p
        })
        return order
      }
    },
  },
  methods: {
    hasAdditional(addInfo, cid) {
      let addInfoBuy = addInfo.additional
      addInfoBuy = addInfoBuy.filter(
        (item) => item.max_qty > 0
      );
      addInfoBuy.forEach(item => {
        let key = cid.toString() + item.aid.toString() //$set key值
        this.$set(this.filterItems, key, {
          name: item.name,
          imageurl: item.image_url,
          carttype: addInfo.cart_type
        })
      })
      this.$emit('itemall', this.filterItems)
    },
    getAPI() {
      this.isLoading = true
      if (!this.isNextPage) {
        return false
      }

      const cacheName = `baseshop_product_${this.category}_${this.pageLimit}_${this.nowPage}`
      const cache = this.storage.get(cacheName, true)
      if (cache) {
        if (cache.payload[0].items.length < this.pageLimit) {
          this.isNextPage = false
        }
        if (this.nowPage === 1) {
          this.firtimeReady = true
        }
        this.nowPage++
        this.parseAPI(cache)
      } else {
        this.axios
          .post(`api/category/page/product?cid=${this.category}&sid=879&hidden=1&rows=${this.pageLimit}&page=${this.nowPage}`)
          .then((res) => {
            this.storage.set(cacheName, res.data, this.configs.webCacheExpireTime, true)
            this.totals = res.data.payload[0].size
            if (res.data.payload[0].items.length < this.pageLimit) {
              this.isNextPage = false
            }
            if (this.nowPage === 1) {
              this.firtimeReady = true
            }
            this.nowPage++
            this.parseAPI(res.data)
          });
      }
    },
    parseAPI(data) {
      if (data.code === 1 && data.payload[0].size > 0) {
        let productData = data.payload[0].items

        productData = productData.filter(v => this.tempItems.indexOf(v.product.pid) === -1)
        productData.forEach(item => {
          this.tempItems.push(item.product.pid)
          this.items.push(item.product);
          this.filterItems[item.product.cid.toString() + item.product.pid.toString()] = {
            name: item.product.name,
            imageurl: item.product.image_url,
            carttype: item.product.cart_type
          }
        })
      }
      this.$emit('itemall', this.filterItems)
      try {
        this.items = this.items.filter(
          //combined組合商品 , sid == 879
          (item) => !item.combined && item.sid === this.configs.sid()
        );
      } catch (e) {
        console.error(e);
      }
      this.isLoading = false
    },
    isInCart() {
      this.isOrder = []
      this.shoppingCart.forEach(i => {
        const filterItemsKeyAry = Object.keys(this.filterItems)
        filterItemsKeyAry.forEach(v => {
          if (i.cpid == v) {
            this.isOrder.push(i.pid)
          }
        })
      })
    },
    addToCart(cartItem) {
      if (this.isAddToCartLoading) {
        return;
      }
      this.isAddToCartLoading = true

      if (!this.ec.addToCartBeforeCheck(this.cartType, cartItem)) return

      this.ec.addToCart(cartItem).then(() => {
        this.storage.set("transactionCartType", this.cartType, this.configs.webCacheExpireTime);
        this.isAddToCartLoading = false;
        const message = new this.fridayMessage({
          name: 'add-to-cart',
          type: 'success',
          message: '商品加入選購清單成功',
          className: 'friday'
        })
        message.init()
        message.show()
        this.$emit("addcart")
        this.showBuyItem = false;
      }).catch(data => {
        this.isAddToCartLoading = false;
        const message = new this.fridayMessage({
          name: 'add-to-cart',
          type: 'warning',
          message: `商品加入選購清單失敗,${data.payload.errorUiMsg}`,
          className: 'friday'
        })
        message.init()
        message.show()
        this.showBuyItem = false;
      })
    },
    productPrice(obj) {
      const tags = [];
      if (obj.tags && obj.tags.length > 0) {
        obj.tags.forEach((i) => {
          tags.push(i.id);
        });
      }
      return obj.special && tags.indexOf(6) === -1 && tags.indexOf(8) === -1 ?
        obj.real_price :
        obj.special_price;
    },
    openDetail(pid, cid) {
      // 由popup看detail方式 改轉單頁
      // this.nowDetailPid = pid;
      // this.nowDetailCid = cid;
      // this.showDetail = true;
      this.$router.push('/product?pid=' + pid + '&cid=' + cid)
    },
    openBuyItem(pid, cid) {
      this.nowDetailPid = pid;
      this.nowDetailCid = cid;
      // this.$emit("stopBodyScroll");
      this.showBuyItem = true;
    },
    closeDetail() {
      this.showDetail = false;
    },
    closeBuyItem() {
      this.$emit("stopBodyScroll", "close");
      this.showBuyItem = false;
    },
    checkIsAvailable(status) {
      return [0, 5].includes(status.id) ? true : false;
    },
    productStatusTxt(status) {
      let txt = ''
      switch (status.id) {
        case 1:
          txt = '預購截止';
          break;
        case 2:
          txt = '尚未開賣';
          break;
        case 3:
        case 4:
          txt = '已售完，補貨中'
          break;
        case 5:
          txt = '點我再折'
          break;
        default:
          txt = '選購';
      }
      return txt
    },
    setCartType(type) {
      this.cartType = type;
    },
  },
  components: {
    productdetail,
    buyitem,
  }
};
</script>

<style lang="scss" scoped>
.ProductList {
  li {
    width: 24.25%;
    margin-right: 1%;
    background-color: #fff;
    border-radius: 10px;
    padding-bottom: 8px;
    float: left;
    margin-bottom: 20px;
    transition: .3s;
    cursor: pointer;

    &:nth-child(4n + 4) {
      margin-right: 0;
    }

    &:hover {
      -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.4);
      box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.4);
      transform: scale(1.05);
    }
  }

  .ProductImg {
    position: relative;

    .orderIcon {
      width: 100px;
      height: 100px;
      background-color: rgba(0, 0, 0, 0.7);
      color: #fff;
      border-radius: 50%;
      position: absolute;
      top: 68px;
      right: 62px;
      z-index: 1;

      @media(max-width:768px) {
        top: 50%;
        right: 50%;
        transform: translate(50%, -50%);
      }

      span {
        display: inline-block;
        margin-top: 50px;
        transform: translate(50%, -50%);
      }
    }
  }
}

.ProductName {
  height: 36px;
  overflow: hidden;
  line-height: 1.4;
  font-size: 0.875rem;
}

@media (max-width: 768px) {
  .ProductList {
    li {
      margin-bottom: 3%;
      width: 48.5%;
      margin-right: 3%;

      &:nth-child(2n + 2) {
        margin-right: 0
      }
    }
  }
}
</style>
